import * as Yup from 'yup'

export default Yup.object({
  FeaturedOn: Yup.string()
})
